import React from 'react'
import './index.scss';
import SvgIcon from '../svg-icon/svg-icon';
import { Link, NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import { Button } from 'semantic-ui-react';

const Footer = () => {
    return (
        <section className='mappes-footer'>
            <div className='mappes-container'>
                <div className='footer-uapper'>
                    <div className='col1'>
                        <Link to="/">
                            <SvgIcon className='logo' name='mappes-logo' viewbox='0 0 136 16' />
                        </Link>
                        <div className='footer-social'>
                            <ul>
                                <li>
                                    <a href='https://in.linkedin.com/company/mappesio' target="_blank"><SvgIcon name='linkedin-alt' viewbox="0 0 20 20" />/mappes.io</a>
                                </li>
                                {/*   <li>
                                <Link to='/'><SvgIcon name='instagram' viewbox="0 0 20 20" />/mappes</Link>
                            </li>
                            <li>
                                <Link to='/'><SvgIcon name='facebook' viewbox="0 0 20 20" />/mappes</Link>
                            </li> */}
                            </ul>
                        </div>
                    </div>
                    <div className='col2 links-col'>
                        <ul>
                            <li><NavLink to='/buyers'>For Technology Providers</NavLink></li>
                            <li><NavLink to='/'>For Technology Sourcing Team</NavLink></li>
                        </ul>
                    </div>
                    <div className='col3 links-col'>
                        <h4>Ecosystem</h4>
                        <ul>
                            <li><NavLink to='/ecosystem/solar'>Solar</NavLink></li>
                            <li><NavLink to='/ecosystem/semiconductors'>Semiconductors</NavLink></li>
                            <li><NavLink to='/ecosystem/optical-fiber'>Optical Fiber and Cable</NavLink></li>
                            <li><NavLink to='/ecosystem/carbon-fiber'>Carbon Fiber</NavLink></li>
                            <li><NavLink to='/ecosystem/green-hydrogen'>Green Hydrogen</NavLink></li>
                            <li><NavLink to='/ecosystem/lithium-ion'>Lithium-Ion Battery</NavLink></li>
                            <li><NavLink to='/ecosystem/additive-manufacturing'>Additive Manufacturing</NavLink></li>
                            <li><NavLink to='/ecosystem/uv-eb-curing'>UV/EB Curing</NavLink></li>
                        </ul>
                    </div>
                    <div className='col4 links-col'>
                        <ul>
                            <li><NavLink to='/mappes-network'>Mappes Network</NavLink></li>
                            <li><NavLink to='/value-chain'>Value Chain</NavLink></li>
                            <li><NavLink to='/event'>Events</NavLink></li>
                            <li><NavLink to='/articles'>Articles</NavLink></li>
                            <li><NavLink to='/aboutus'>About Us</NavLink></li>
                            <li><NavLink to='/FAQs'>FAQs</NavLink></li>
                            <li><NavLink to='/careers'>Careers</NavLink></li>
                        </ul>
                        <div className='mt-4'><Link to='/contact-us'><Button primary>Contact us</Button></Link></div>
                    </div>
                </div>
                <div className='footer-bottom'>
                    Terms & Conditions | Privacy Policy <br />
                    © 2024 Mappes Inc.
                </div>
            </div>
        </section>
    )
}

export default Footer